import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from './store';

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      meta: {
        title: '个人中心'
      },
      component: () => import( '@/views/index.vue')
    },
    {
      path: '/shopInfo',
      name: 'shopInfo',
      meta: {
        title: '消费详情'
      },
      component: () => import( '@/views/shopInfo.vue')
    },   
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '登录页面'
      },
      component: () => import( '@/views/login.vue')
    },
    {
      path: '/payItem',
      name: 'payItem',
      meta: {
        title: '消费详情'
      },
      component: () => import( '@/views/payItem.vue')
    },
    {
      path: '/payInfo',
      name: 'payInfo',
      meta: {
        title: '消费记录'
      },
      component: () => import( '@/views/payInfo.vue')
    }
  ]
});

// 登陆验证
router.beforeEach((to, from, next) => {
  const whiteArr = ['login'];
  if (!Store.getters.token && whiteArr.indexOf(to.name) === -1) {
    next({ path: '/login' });
  } else {
    next();
  }
});

export default router;
